import { c as _c } from "react/compiler-runtime";
import { discoveryTileImageSource } from '@material-bank/mtag-utilities';
import { LoadingImage } from '../LoadingImage/LoadingImage';
import { SelectedTileOverlay } from '../SelectedTileOverlay/SelectedTileOverlay';

// Canonical material swatch tile shared by Find Similar and Pairs With.
// Matches Figma (node 17032:16873): a 24px-radius square with `shadow-sm`.
const RADIUS = 'rounded-[24px]';
type SwatchTileProps = {
  imageUrl: string;
  name: string;
  onClick?: () => void;
  isLoading?: boolean;
  selected?: boolean;
  // Above-the-fold tiles load eagerly so a cached image can settle at mount;
  // the rest stay lazy.
  loading?: 'lazy' | 'eager';
};
export function SwatchTile(t0) {
  const $ = _c(21);
  const {
    imageUrl,
    name,
    isLoading: t1,
    selected: t2,
    loading: t3,
    onClick
  } = t0;
  const isLoading = t1 === undefined ? false : t1;
  const selected = t2 === undefined ? false : t2;
  const loading = t3 === undefined ? "lazy" : t3;
  if (!imageUrl) {
    return null;
  }
  let t4;
  if ($[0] !== imageUrl) {
    t4 = discoveryTileImageSource(imageUrl);
    $[0] = imageUrl;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const image = t4;
  let t5;
  if ($[2] !== image.src || $[3] !== image.srcSet || $[4] !== loading || $[5] !== name) {
    t5 = <div className={`relative isolate aspect-square w-full overflow-hidden ${RADIUS}`}><LoadingImage src={image.src} srcSet={image.srcSet} alt={name} wrapperClassName="block h-full w-full" className="h-full w-full object-cover" skeletonClassName={RADIUS} loading={loading} /></div>;
    $[2] = image.src;
    $[3] = image.srcSet;
    $[4] = loading;
    $[5] = name;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== selected) {
    t6 = <SelectedTileOverlay selected={selected} radiusClassName={RADIUS} />;
    $[7] = selected;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const content = t7;
  if (onClick) {
    const t8 = `relative isolate block w-full overflow-hidden ${RADIUS} shadow-sm transition-transform duration-100 ease-out active:scale-[0.98]${isLoading ? " animate-pulse cursor-not-allowed opacity-60" : " cursor-pointer"}`;
    let t9;
    if ($[12] !== content || $[13] !== isLoading || $[14] !== name || $[15] !== onClick || $[16] !== selected || $[17] !== t8) {
      t9 = <button type="button" onClick={onClick} disabled={isLoading} aria-disabled={isLoading} aria-busy={isLoading} aria-pressed={selected} aria-label={name} className={t8}>{content}</button>;
      $[12] = content;
      $[13] = isLoading;
      $[14] = name;
      $[15] = onClick;
      $[16] = selected;
      $[17] = t8;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    return t9;
  }
  let t8;
  if ($[19] !== content) {
    t8 = <div className={`relative isolate overflow-hidden ${RADIUS} shadow-sm`}>{content}</div>;
    $[19] = content;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}